import { render, staticRenderFns } from "./BoxScore.vue?vue&type=template&id=37abeb6a&scoped=true&"
import script from "./BoxScore.vue?vue&type=script&lang=ts&"
export * from "./BoxScore.vue?vue&type=script&lang=ts&"
import style0 from "./BoxScore.vue?vue&type=style&index=0&id=37abeb6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abeb6a",
  null
  
)

export default component.exports